import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/components/home'
import chime from '@/components/chime.vue'
import chimefrb from '@/components/chimefrb'
import analysis from '@/components/analysis'
import voevent_info from '@/components/voevent_info'
import event from '@/components/event'
import latest from '@/components/latest'
import repeaters from '@/components/repeaters'
import galactic from '@/components/galactic'
import astronomyTools from '@/components/astronomyTools'
import catalog from '@/components/catalog'
import catalog_event from '@/components/catalog_event'
import repeater_catalog from '@/components/repeater_catalog'
import baseband_catalog_1 from '@/components/baseband_catalog_1'

Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    hash: false,
    routes: [
        {
            path: '/',
            name: 'home',
            component: home
        },
        {
            path: '/chime',
            name: 'chime',
            component: chime
        },
        {
            path: '/chimefrb',
            name: 'chimefrb',
            component: chimefrb
        },
        {
            path: '/analysis',
            name: 'analysis',
            component: analysis
        },
        {
            path: '/voevents',
            name: 'voevent_info',
            component: voevent_info
        },
        {
            path: '/astronomytools',
            name: 'astronomyTools',
            component: astronomyTools
        },
        {
            path: '/latest',
            name: 'latest',
            component: latest
        },
        {
             path: '/catalog',
             name: 'catalog',
             component: catalog
        },
        {
            path: '/repeater_catalog',
            name: 'repeater_catalog',
            component: repeater_catalog
        },
        {
            path: '/baseband-catalog-1',
            name: 'baseband_catalog_1',
            component: baseband_catalog_1
        },
        {
            path: '/repeaters',
            name: 'repeaters',
            component: repeaters
        },
        {
            path: '/galactic',
            name: 'galactic',
            component: galactic
        },
        {
            path: '/latest/:id',
            component: event
        },
        {
            path: '/repeaters/:id',
            component: event
        },
        {
             path: '/catalog/:id',
             component: catalog_event
        },
        {
            path: '/galactic/:id',
            component: event
        }
    ]
})
